import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Check, Star } from 'lucide-react';
export const Hero: React.FC = () => {
  return <section className="relative bg-stone-50 overflow-hidden pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-55">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-56">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-amber-300 blur-3xl" data-id="element-57"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 rounded-full bg-green-300 blur-3xl" data-id="element-58"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-59">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-60">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center md:text-left" data-id="element-61">
            <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-semibold mb-6" data-id="element-62">
              <Star className="w-4 h-4 fill-current" data-id="element-63" />
              <span data-id="element-64">Acceso inmediato • Descarga digital</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6" data-id="element-65">
              Ciencias Naturales{' '}
              <span className="text-green-700" data-id="element-66">listas para todo el año</span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-67">
              Actividades, guías, experimentos simples y evaluaciones listas
              para usar. Diseñadas para docentes que quieren clases más claras,
              más participativas y con estructura real…{' '}
              <span className="font-semibold text-gray-800" data-id="element-68">
                sin improvisar.
              </span>
            </p>

            <ul className="space-y-3 mb-8 text-left max-w-lg mx-auto md:mx-0" data-id="element-69">
              {['Planificación anual + por unidades (Biología, Física y Química)', 'Guías imprimibles listas para aula', 'Experimentos y prácticas fáciles (sin laboratorio)', 'Evaluaciones listas por unidad + pautas'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-70">
                  <div className="mt-1 bg-green-100 p-0.5 rounded-full" data-id="element-71">
                    <Check className="w-4 h-4 text-green-700" data-id="element-72" />
                  </div>
                  <span className="text-gray-700" data-id="element-73">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-74">
              <CTAButton text="Sí, quiero el MegaPack ahora" data-id="element-75" />
            </div>

            <p className="mt-4 text-sm text-gray-500" data-id="element-76">
              Acceso inmediato – descarga digital al finalizar la compra
            </p>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-77">
            <div className="relative z-10 transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/urJyZr5YB2L2wVr7YeMCh2/producto_1.png" alt="MegaPack Ciencias Naturales Libro Digital" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-79" />
            </div>
            {/* Shadow/Platform effect */}
            <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 w-3/4 h-8 bg-black/20 blur-xl rounded-full" data-id="element-80"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};